// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;
  --font-sans: "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-serif: "Playfair Display", Georgia, "Times New Roman", serif;
  --font-mono: "JetBrains Mono", "Menlo", "Monaco", "Courier New", monospace;
  --bg: #f0ebe4;
  --bg-deep: #e6e0d8;
  --surface: rgba(255, 255, 255, 0.92);
  --surface-strong: rgba(255, 255, 255, 0.98);
  --surface-soft: rgba(255, 255, 255, 0.75);
  --border: rgba(0, 0, 0, 0.08);
  --border-strong: rgba(0, 0, 0, 0.15);
  --text: #0f0c29;
  --text-soft: #3d3960;
  --text-muted: #7c78a0;
  --accent: #2b4a5c;
  --accent-strong: #1e3a4a;
  --accent-soft: #4a6b7d;
  --accent-wash: rgba(43, 74, 92, 0.08);
  --accent-wash-2: rgba(43, 74, 92, 0.14);
  --positive: #059669;
  --negative: #dc2626;
  --complex: #d97706;
  --panel-shadow: 0 4px 24px rgba(0, 0, 0, 0.09);
  --shadow-button: 0 10px 24px rgba(30, 58, 74, 0.28);
  --shadow-active-tab: 0 2px 8px rgba(30, 58, 74, 0.26);
  --gradient-analyze: linear-gradient(135deg, #3a5f72, #1e3a4a);
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  margin: 0;
  font-family: var(--font-sans);
  background:
    radial-gradient(ellipse at top left, rgba(43, 74, 92, 0.07), transparent 45%),
    radial-gradient(ellipse at bottom right, rgba(43, 74, 92, 0.05), transparent 40%),
    #f0ebe4;
  color: var(--text);
}

button,
input,
select,
textarea {
  font: inherit;
}

button {
  cursor: pointer;
}

.app-shell {
  position: relative;
  min-height: 100vh;
  padding: 60px 28px 128px;
}

.ambient-orb {
  position: fixed;
  z-index: 0;
  width: 24rem;
  height: 24rem;
  border-radius: 999px;
  filter: blur(92px);
  opacity: 0.28;
  pointer-events: none;
}

.ambient-orb-left {
  top: -6rem;
  left: -8rem;
  background: rgba(43, 74, 92, 0.12);
}

.ambient-orb-right {
  right: -8rem;
  bottom: 5rem;
  background: rgba(43, 74, 92, 0.08);
}

.masthead,
.notice-banner,
.control-deck,
.tab-row,
.content-frame,
.summary-ribbon {
  position: relative;
  z-index: 1;
}

.masthead {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  align-items: start;
  margin: 0 auto 34px;
  max-width: 1480px;
}

.masthead-copy {
  display: grid;
  justify-items: center;
  margin: 0 auto;
  text-align: center;
}

.eyebrow,
.panel-kicker {
  font-family: var(--font-sans);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--accent);
  font-size: 0.72rem;
}

.masthead h1 {
  margin: 0 auto;
  font-family: var(--font-serif);
  max-width: 19ch;
  font-size: clamp(2rem, 4.2vw, 4rem);
  line-height: 1.03;
  letter-spacing: -0.01em;
  font-weight: 800;
  color: var(--text);
}

.masthead h1.ripple-logo {
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.masthead h1.ripple-logo:hover {
  opacity: 0.85;
}

.masthead h1 span {
  color: var(--accent);
}

.masthead-subtitle {
  margin-top: 8px;
  color: var(--text-soft);
  font-size: 1.25rem;
}

.home-button {
  background: rgba(0, 119, 204, 0.12);
  border: 1px solid rgba(0, 119, 204, 0.3);
  color: #0077cc;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.home-button:hover {
  background: rgba(0, 119, 204, 0.2);
  border-color: rgba(0, 119, 204, 0.5);
}

.masthead-subsection {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  color: var(--text-soft);
  font-size: 0.96rem;
  justify-self: center;
}

.masthead-subsection span {
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.72rem;
}

.portfolio-ticker-row {
  letter-spacing: 0.01em;
}

.portfolio-separator {
  color: var(--text-muted);
}

.meta-pill {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid var(--border);
  box-shadow: var(--panel-shadow);
  backdrop-filter: blur(16px);
}

.meta-pill span {
  color: var(--text-muted);
  font-size: 0.84rem;
}

.meta-pill strong {
  text-align: right;
  font-size: 0.92rem;
}

.meta-live {
  border-color: rgba(103, 168, 127, 0.28);
}

.meta-mock {
  border-color: rgba(201, 181, 138, 0.28);
}

.notice-banner {
  max-width: 1480px;
  margin: 0 auto 32px;
  padding: 14px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid var(--border);
  color: var(--text-soft);
}

.notice-below-controls {
  margin-top: 28px;
}

.control-deck,
.tab-row,
.panel-surface,
.effect-graph-shell,
.summary-ribbon {
  max-width: 1480px;
  margin-left: auto;
  margin-right: auto;
}

.control-cluster {
  width: min(100%, 1480px);
  margin: 0 auto 30px;
}

.content-frame {
  display: grid;
  gap: 28px;
}

.graph-top-section {
  display: grid;
  gap: 28px;
}

.content-frame > * {
  width: min(100%, 1480px);
  margin-left: auto;
  margin-right: auto;
}

.control-deck {
  display: grid;
  grid-template-columns: minmax(180px, 1.25fr) repeat(2, minmax(112px, 0.6fr)) minmax(180px, 1fr) minmax(220px, 1.2fr) auto;
  gap: 14px;
  padding: 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid var(--border);
  box-shadow: var(--panel-shadow);
  backdrop-filter: blur(16px);
  margin-bottom: 0;
}

.control-callout {
  display: grid;
  justify-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.control-callout-button {
  border: none;
  padding: 13px 24px;
  border-radius: 999px;
  background:
    linear-gradient(135deg, rgba(241, 214, 161, 0.98), rgba(201, 181, 138, 0.98));
  color: #142033;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow:
    0 14px 28px rgba(9, 14, 22, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
}

.control-callout-button:hover {
  transform: translateY(-1px);
  box-shadow:
    0 16px 30px rgba(9, 14, 22, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.control-callout-link {
  width: 2px;
  height: 22px;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(235, 207, 152, 0.9), rgba(201, 181, 138, 0.1));
}

.control-group {
  display: grid;
  gap: 8px;
}

.control-group label {
  font-family: var(--font-sans);
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
}

.control-group select,
.control-group input,
.surface-actions input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--border-strong);
  color: var(--text);
  box-shadow: none;
  font-size: 1rem;
}

.compact input {
  min-width: 0;
}

.slider-group .slider-shell {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 14px;
  align-items: center;
}

.slider-shell input[type="range"] {
  padding: 0;
}

.slider-shell strong {
  font-family: var(--font-sans);
}

.analyze-button {
  align-self: end;
  padding: 14px 22px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #3a5f72, #1e3a4a);
  color: #ffffff;
  font-weight: 700;
  min-height: 52px;
  font-size: 1rem;
  box-shadow: 0 10px 24px rgba(30, 58, 74, 0.28);
}

.analyze-button:disabled {
  opacity: 0.7;
  cursor: wait;
}

.tab-row {
  display: flex;
  gap: 6px;
  width: fit-content;
  max-width: 100%;
  margin-top: 12px;
  margin-bottom: 34px;
  margin-left: auto;
  margin-right: auto;
  padding: 8px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--border);
}

.tab {
  border: none;
  padding: 11px 14px;
  border-radius: 12px;
  background: transparent;
  color: var(--text-muted);
  font-weight: 600;
}

.tab.active {
  background: var(--accent);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(43, 74, 92, 0.28);
}

.effect-graph-shell {
  display: grid;
  grid-template-columns: 240px 1fr 340px;
  gap: 24px;
}


.graph-stage,
.graph-detail-panel,
.roster-panel,
.panel-surface {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--panel-shadow);
  backdrop-filter: blur(16px);
}

.custom-panel {
  padding: 24px;
  overflow-y: auto;
  max-height: 680px;
}

.graph-stage {
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 680px;
  overflow: hidden;
}

.graph-toolbar,
.graph-footer {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: center;
  padding: 18px 22px;
}

.graph-toggle,
.graph-slider {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-soft);
  font-size: 0.88rem;
}

.graph-slider input[type="range"] {
  width: 120px;
}

.graph-slider strong,
.graph-footer span,
.panel-stat-card strong,
.summary-list strong {
  font-family: var(--font-sans);
}

.graph-canvas-wrap {
  min-height: 600px;
  background:
    radial-gradient(ellipse at center, rgba(230, 235, 245, 0.9) 0%, rgba(220, 228, 240, 0.95) 66%, rgba(210, 220, 235, 1) 100%);
}

.graph-canvas {
  width: 100%;
  height: 100%;
  min-height: 600px;
  display: block;
}

.graph-footer {
  border-top: 1px solid var(--border);
  color: var(--text-muted);
  font-size: 0.82rem;
}

.graph-detail-panel {
  overflow: hidden;
}

.graph-panel-body {
  padding: 24px;
  height: 100%;
  overflow-y: auto;
}

.panel-title {
  margin: 10px 0 8px;
  font-family: var(--font-sans);
  font-size: 1.68rem;
}

.panel-copy {
  margin: 0;
  color: var(--text-soft);
  line-height: 1.6;
}

.panel-copy.strong {
  color: var(--text);
}

.panel-section {
  margin-top: 22px;
}

.inline-heading {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: baseline;
}

.inline-hint {
  color: var(--text-muted);
  font-size: 0.82rem;
}

.panel-section-title {
  margin: 0 0 12px;
  color: var(--text);
  font-size: 0.96rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.panel-stat-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.panel-stat-card,
.effect-card,
.mini-case-card,
.case-card,
.evidence-card,
.empty-state-card,
.selector-card {
  border-radius: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
}

.panel-stat-card {
  display: grid;
  gap: 6px;
  padding: 14px;
}

.panel-stat-label {
  color: var(--text-muted);
  font-size: 0.78rem;
}

.roster-list,
.selector-grid {
  display: grid;
  gap: 10px;
}

.roster-chip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  padding: 11px 13px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  color: var(--text-soft);
}

.roster-swatch {
  width: 10px;
  height: 10px;
  border-radius: 999px;
}

.summary-list {
  display: grid;
  gap: 10px;
}

.summary-list.compact {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.summary-list div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
}

.summary-list span {
  color: var(--text-muted);
}

.signal-list,
.effect-list,
.case-card-stack {
  display: grid;
  gap: 12px;
}

.signal-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--border);
}

.signal-metric {
  color: var(--text-soft);
}

.effect-card,
.mini-case-card,
.case-card {
  padding: 16px;
}

.effect-card p,
.mini-case-card p,
.case-card p {
  margin: 0;
  color: var(--text-soft);
  line-height: 1.55;
}

.effect-card-head,
.case-card-topline,
.case-card-stats,
.case-card-foot,
.mini-case-header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.effect-card-head,
.case-card-topline,
.mini-case-header {
  margin-bottom: 10px;
  align-items: center;
}

.effect-card-confidence,
.case-card-topline span,
.case-card-stats span,
.case-card-foot span,
.mini-case-header span {
  color: var(--text-muted);
  font-size: 0.82rem;
}

.case-card-stats,
.case-card-foot {
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.case-counterexample {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 107, 92, 0.08);
  color: #ffb2a7;
  font-size: 0.86rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.2rem;
  padding: 5px 9px;
  border-radius: 999px;
  font-family: var(--font-sans);
  font-size: 0.68rem;
  font-weight: 700;
  white-space: nowrap;
}

.badge-l1 {
  background: rgba(5, 150, 105, 0.1);
  color: #047857;
}

.badge-l2 {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}

.badge-l3 {
  background: rgba(43, 74, 92, 0.12);
  color: #1e3a4a;
}

.content-frame {
  min-height: 720px;
}

.panel-surface {
  padding: 24px;
}

.surface-header {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: start;
  margin-bottom: 22px;
}

.surface-header h2 {
  margin: 10px 0 0;
  font-family: var(--font-serif);
  font-size: 2rem;
}

.surface-actions {
  display: flex;
  gap: 10px;
}

.surface-actions button {
  padding: 11px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--border-strong);
  color: var(--text);
}

.surface-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.input-actions {
  min-width: min(100%, 340px);
}

.brief-block {
  margin: 0;
  padding: 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid var(--border);
  color: var(--text);
  overflow: auto;
  white-space: pre-wrap;
  font-family: var(--font-sans);
  line-height: 1.6;
}

.filter-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.filter-strip span {
  padding: 10px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--border);
  color: var(--text-soft);
}

.selector-card {
  display: grid;
  gap: 6px;
  padding: 16px;
  text-align: left;
  color: var(--text-soft);
}

.selector-card strong {
  color: var(--text);
}

.empty-surface-copy {
  padding: 20px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--border);
  color: var(--text-soft);
}

.case-card-grid,
.raw-grid {
  display: grid;
  gap: 18px;
}

.raw-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.raw-column h3 {
  margin-top: 0;
  margin-bottom: 14px;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.summary-ribbon {
  position: fixed;
  left: 28px;
  right: 28px;
  bottom: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 14px 18px;
  border-radius: 16px;
  background: rgba(24, 35, 51, 0.94);
  border: 1px solid rgba(201, 181, 138, 0.14);
  backdrop-filter: blur(18px);
  color: var(--text-soft);
}

.mock-footer-status {
  text-align: center;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  margin: 40px auto 0;
  max-width: 1480px;
  color: var(--text-muted);
  font-size: 0.9rem;
  border: 1px solid var(--border);
}

.status-connected {
  color: #10b981; /* Green */
}

/* Roster Sidebar Styles */
.roster-panel {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.roster-heading {
  margin: 0 0 16px;
  font-size: 0.8rem;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  text-transform: uppercase;
}

.roster-list-sidebar {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.roster-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  color: var(--text);
  transition: all 0.2s;
  text-align: left;
}

.roster-item:hover {
  background: rgba(0, 0, 0, 0.04);
}

.roster-item.selected {
  background: rgba(43, 74, 92, 0.08);
  border-color: rgba(43, 74, 92, 0.2);
}

.roster-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Switch styling */
.switch-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #dce4ee;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider.round {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #334155;
  transition: .4s;
  border-radius: 34px;
}
.slider.round:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}
input:checked + .slider.round {
  background-color: #ebcf98;
}
input:checked + .slider.round:before {
  transform: translateX(16px);
  background-color: #122033;
}

/* Progress bars */
.progress-bars {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 0.85rem;
  color: #dce4ee;
}
.progress-row span {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.progress-track {
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
}
.progress-fill {
  height: 100%;
  background: rgba(135, 206, 235, 0.8);
  border-radius: 3px;
}

/* ── Audit Trail ──────────────────────────────────────────────────────────────
   These styles power the ⓘ expand buttons and the panels they reveal.
   The design philosophy: subtle by default (low-opacity gold ⓘ), rich on click.
   Everything uses existing CSS variables so it auto-fits the dark theme.
   ────────────────────────────────────────────────────────────────────────── */

/* Wrapper keeps the button and the expanding panel stacked vertically */
.audit-wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
}

/* The ⓘ button itself — small, gold, unobtrusive */
.audit-toggle-btn {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font-size: 11px;
  padding: 0 2px;
  opacity: 0.65;
  transition: opacity 0.15s;
  line-height: 1;
  vertical-align: middle;
}
.audit-toggle-btn:hover { opacity: 1; }

/* The expandable panel */
.audit-panel {
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid var(--border-strong);
  border-radius: 6px;
  padding: 10px 12px;
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.7;
  min-width: 210px;
  max-width: 300px;
  color: var(--text-soft);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  white-space: normal;
}

/* Section header inside the panel */
.audit-section-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--accent);
  margin-bottom: 6px;
}

/* Each row: label on the left, value on the right */
.audit-step {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0;
  border-bottom: 1px solid var(--border);
}
.audit-step:last-of-type { border-bottom: none; }

.audit-step-label { color: var(--text-muted); white-space: nowrap; }
.audit-step-value { text-align: right; }
.audit-step-note  { color: var(--text-muted); font-size: 10px; }

/* Monospace formula line — makes the arithmetic readable at a glance */
.audit-formula {
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: var(--accent);
  background: rgba(43, 74, 92, 0.07);
  border-radius: 4px;
  padding: 4px 6px;
  margin: 6px 0 4px;
  word-break: break-all;
}

/* Source citation — italicised, muted */
.audit-source {
  font-size: 10px;
  color: var(--text-muted);
  font-style: italic;
  margin-top: 4px;
}

/* ── Material Change List (node detail panel) ─────────────────────────────── */
.material-change-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Each row: metric name left, arrow + % + optional ⓘ right */
.material-change-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  gap: 12px;
}

.material-change-metric {
  color: var(--text-soft);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-change-value {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  flex-shrink: 0;
}

@media (max-width: 1200px) {
  .masthead,
  .effect-graph-shell,
  .control-deck,
  .raw-grid {
    grid-template-columns: 1fr;
  }

  .graph-stage {
    min-height: 640px;
  }

  .graph-canvas-wrap,
  .graph-canvas {
    min-height: 560px;
  }
}

@media (max-width: 860px) {
  .app-shell {
    padding: 32px 16px 96px;
  }

  .control-deck {
    grid-template-columns: 1fr;
  }

  .control-callout {
    margin-bottom: 12px;
  }

  .graph-toolbar,
  .surface-header {
    flex-direction: column;
    align-items: stretch;
  }

  .tab-row {
    overflow-x: auto;
  }

  .summary-ribbon {
    left: 16px;
    right: 16px;
    bottom: 12px;
  }
}

/* ══════════════════════════════════════════════════════════════════════════════
   FINANCIAL METRICS TAB + EXPORT BAR + PIPELINE FOOTER
   Added for mentor demo — all new classes, no overrides.
   ══════════════════════════════════════════════════════════════════════════ */

/* ── Export bar in masthead ────────────────────────────────────────────────── */
.export-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
}

.export-bar-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-muted);
  margin-right: 4px;
}

.export-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 8px;
  background: rgba(43, 74, 92, 0.08);
  border: 1px solid rgba(43, 74, 92, 0.2);
  color: var(--accent);
  font-size: 0.82rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s;
}

.export-button:hover {
  background: rgba(43, 74, 92, 0.16);
  color: var(--accent-strong);
}

/* ── Pipeline stats footer ────────────────────────────────────────────────── */
.pipeline-stats-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  padding: 18px;
  margin: 40px auto 0;
  max-width: 1480px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.stat-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 18px;
}

.stat-pill strong {
  font-size: 1.1rem;
  color: var(--text);
  font-family: var(--font-sans);
}

.stat-pill span {
  font-size: 0.72rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* ── Metrics tab ──────────────────────────────────────────────────────────── */
.metrics-surface {
  padding: 28px;
}

.metrics-surface h2 {
  margin: 8px 0 0;
  font-family: var(--font-sans);
  font-size: 1.8rem;
}

.metrics-company-select {
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--border-strong);
  color: var(--text);
  font-size: 0.88rem;
}

/* ── Anomaly alerts ───────────────────────────────────────────────────────── */
.anomaly-strip {
  display: grid;
  gap: 10px;
  margin-bottom: 24px;
}

.anomaly-card {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(248, 113, 113, 0.06);
  border: 1px solid rgba(248, 113, 113, 0.15);
}

.anomaly-card.anomaly-divergence {
  background: rgba(251, 191, 36, 0.06);
  border-color: rgba(251, 191, 36, 0.15);
}

.anomaly-icon {
  font-size: 1.2rem;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 2px;
}

.anomaly-card strong {
  color: var(--text);
  font-size: 0.9rem;
}

.anomaly-card p {
  margin: 4px 0 0;
  color: var(--text-soft);
  font-size: 0.86rem;
  line-height: 1.5;
}

/* ── Company pills row ────────────────────────────────────────────────────── */
.metrics-summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 28px;
}

.metrics-company-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 12px 18px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--border);
  color: var(--text-soft);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.metrics-company-pill:hover {
  border-color: var(--border-strong);
  background: rgba(255, 255, 255, 0.95);
}

.metrics-company-pill.active {
  border-color: var(--accent);
  background: rgba(43, 74, 92, 0.08);
}

.metrics-company-pill strong {
  font-size: 1rem;
  color: var(--text);
}

.metrics-company-pill span {
  font-size: 0.74rem;
  color: var(--text-muted);
}

/* ── Metric group + table ─────────────────────────────────────────────────── */
.metrics-group {
  margin-bottom: 28px;
}

.metrics-group-title {
  margin: 0 0 12px;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.metrics-table-wrap {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid var(--border);
}

.metrics-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;
}

.metrics-table th {
  padding: 10px 14px;
  text-align: right;
  font-weight: 600;
  color: var(--text-muted);
  font-size: 0.88rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid var(--border);
}

.metrics-table th:first-child {
  text-align: left;
}

.metrics-subheader th {
  font-size: 0.68rem;
  padding: 6px 14px;
  color: var(--text-muted);
  opacity: 0.7;
}

.metrics-table td {
  padding: 10px 14px;
  text-align: right;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  color: var(--text-soft);
}

.metric-name {
  text-align: left !important;
  color: var(--text) !important;
  font-weight: 500;
  white-space: nowrap;
}

.metric-value.dim,
.metric-change.dim {
  color: var(--text-muted);
  opacity: 0.5;
}

.metric-alert {
  font-weight: 600;
}

.metric-alert-dot {
  margin-left: 4px;
  color: var(--negative);
  font-size: 0.78rem;
}

.change-positive { color: var(--positive); }
.change-negative { color: var(--negative); }
.change-neutral  { color: var(--text-muted); }

/* ── Methodology footnote ─────────────────────────────────────────────────── */
.metrics-methodology {
  margin-top: 28px;
  padding: 14px 18px;
  border-radius: 10px;
  background: var(--surface-soft);
  border: 1px solid var(--border);
  color: var(--text-muted);
  font-size: 0.82rem;
  line-height: 1.6;
}

/* ═══════════════════════════════════════════════════════════════════════════
 * PITCH VIEW
 * ═══════════════════════════════════════════════════════════════════════════ */

.pitch-root {
  max-width: 1100px;
  margin: 0 auto;
}

.pitch-section {
  padding: 56px 24px;
  border-bottom: 1px solid var(--border);
}

.pitch-section--alt {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  margin: 8px 0;
  border: 1px solid var(--border);
}

.pitch-section-title {
  font-family: var(--font-serif);
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0 0 28px;
  text-align: center;
}

/* Hero */
.pitch-hero {
  text-align: center;
  padding: 80px 24px 64px;
}

.pitch-hero-title {
  font-size: clamp(2.4rem, 5vw, 4.2rem);
  font-weight: 800;
  letter-spacing: -0.04em;
  margin: 0;
  background: linear-gradient(135deg, #f0f2f5 0%, rgba(235, 207, 152, 0.9) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.pitch-hero-subtitle {
  font-size: 1.15rem;
  color: var(--text-soft);
  margin: 8px 0 0;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: 500;
}

.pitch-hero-tagline {
  font-size: 1.05rem;
  color: var(--text-muted);
  margin: 24px auto 0;
  max-width: 540px;
  line-height: 1.65;
  font-style: italic;
}

.pitch-hero-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 32px;
  flex-wrap: wrap;
}

.pitch-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3a5f72, #1e3a4a);
  color: #fff;
  font-weight: 600;
  font-size: 0.92rem;
  border: none;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  text-decoration: none;
}

.pitch-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(30, 58, 74, 0.4);
}

.pitch-cta-secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 10px;
  background: transparent;
  color: var(--text-soft);
  font-weight: 600;
  font-size: 0.92rem;
  border: 1px solid var(--border-strong);
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.15s;
}

.pitch-cta-secondary:hover {
  border-color: var(--accent);
  color: #fff;
}

/* Cards row */
.pitch-cards-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.pitch-cards-row--two {
  grid-template-columns: repeat(2, 1fr);
  max-width: 700px;
  margin: 0 auto;
}

.pitch-cards-row--market {
  grid-template-columns: repeat(2, 1fr);
  max-width: 1040px;
  margin: 0 auto;
}

.pitch-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.pitch-card h3 {
  font-size: 1.2rem;
  margin: 0 0 10px;
  color: var(--text);
}

.pitch-card p {
  font-size: 1rem;
  color: var(--text-soft);
  line-height: 1.6;
  margin: 0 0 8px;
}

.pitch-card ul {
  margin: 8px 0 0;
  padding-left: 18px;
  font-size: 0.86rem;
  color: var(--text-soft);
  line-height: 1.7;
}

.pitch-card--stat {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* Pipeline diagram */
.pitch-pipeline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow-x: auto;
  padding: 12px 0;
}

.pitch-pipeline-step {
  flex: 1;
  min-width: 140px;
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 18px 14px;
  text-align: center;
}

.pitch-pipeline-step--final {
  border-color: var(--accent);
  background: rgba(43, 74, 92, 0.06);
}

.pitch-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--accent);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.pitch-pipeline-step h4 {
  font-size: 0.82rem;
  margin: 0 0 6px;
  color: var(--text);
}

.pitch-pipeline-step p {
  font-size: 0.76rem;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.5;
}

.pitch-pipeline-arrow {
  display: flex;
  align-items: center;
  color: var(--text-muted);
  font-size: 1.2rem;
  padding-top: 30px;
  flex-shrink: 0;
}

/* Stat bar */
.pitch-stat-bar {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.pitch-stat {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pitch-stat-number {
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: rgba(235, 207, 152, 0.95);
}

.pitch-stat-label {
  font-size: 0.78rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* Comparison table */
.pitch-table-wrap {
  overflow-x: auto;
}

.pitch-comparison-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.86rem;
}

.pitch-comparison-table th,
.pitch-comparison-table td {
  padding: 10px 14px;
  text-align: center;
  border-bottom: 1px solid var(--border);
}

.pitch-comparison-table th {
  background: var(--surface-strong);
  color: var(--text-soft);
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.pitch-comparison-table td:first-child {
  text-align: left;
  font-weight: 500;
  color: var(--text);
}

.pitch-comparison-table tbody tr:nth-child(even) {
  background: rgba(0, 0, 0, 0.02);
}

.pitch-highlight-col {
  background: rgba(43, 74, 92, 0.08) !important;
  color: var(--accent) !important;
}

.pitch-symbol-cell {
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1;
}

.pitch-yes { color: var(--positive); font-weight: 600; }
.pitch-no { color: var(--negative); opacity: 0.6; }
.pitch-partial { color: var(--complex); }

/* Expandable */
.pitch-expandable { margin-top: 8px; }

.pitch-expanded {
  margin-top: 16px;
  animation: pitch-fade-in 0.3s ease;
}

.pitch-expand-btn {
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 0;
  margin-top: 8px;
}

.pitch-expand-btn:hover { text-decoration: underline; }

.pitch-body {
  font-size: 1.05rem;
  color: var(--text-soft);
  line-height: 1.65;
  margin: 0;
}

@keyframes pitch-fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Tier diagram */
.pitch-tier-diagram {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.pitch-tier {
  border-radius: 14px;
  padding: 20px;
  border: 1px solid var(--border);
}

.pitch-tier h4 {
  margin: 0 0 8px;
  font-size: 0.9rem;
}

.pitch-tier p {
  font-size: 0.82rem;
  color: var(--text-soft);
  margin: 0 0 8px;
}

.pitch-tier ul {
  margin: 0;
  padding-left: 16px;
  font-size: 0.8rem;
  color: var(--text-muted);
  line-height: 1.7;
}

.pitch-tier--high {
  background: rgba(16, 185, 129, 0.06);
  border-color: rgba(16, 185, 129, 0.2);
}

.pitch-tier--low {
  background: rgba(245, 158, 11, 0.06);
  border-color: rgba(245, 158, 11, 0.2);
}

/* Footer */
.pitch-footer-section {
  text-align: center;
  border-bottom: none;
}

.pitch-footer-quote {
  font-size: 1.15rem;
  font-style: italic;
  color: var(--accent);
  margin: 0 0 24px;
}

.pitch-footer-credits {
  font-size: 0.88rem;
  color: var(--text-soft);
  line-height: 1.7;
}

.pitch-footer-credits p { margin: 2px 0; }

/* ═══════════════════════════════════════════════════════════════════════════
 * TARIFF VIEW
 * ═══════════════════════════════════════════════════════════════════════════ */

.tariff-surface {
  max-width: 1200px;
  margin: 0 auto;
}

.tariff-controls {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  padding: 20px 24px;
  background: var(--surface-strong);
  border-radius: 14px;
  margin: 16px 24px;
  align-items: flex-end;
}

.tariff-control-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
}

.tariff-control-group label {
  font-size: 0.85rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.tariff-control-group select,
.tariff-control-group input[type="number"] {
  padding: 8px 12px;
  background: var(--bg);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  color: var(--text);
  font-size: 1rem;
}

.tariff-rate-input {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tariff-rate-input input {
  width: 72px;
}

.tariff-rate-input span {
  color: var(--text-muted);
  font-weight: 600;
}

.tariff-slider {
  width: 100%;
  accent-color: var(--accent);
  margin-top: 4px;
}

/* Insight bar */
.tariff-insight-bar {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 20px;
  margin: 0 24px;
  background: rgba(248, 113, 113, 0.06);
  border: 1px solid rgba(248, 113, 113, 0.15);
  border-radius: 14px;
}

.tariff-insight {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tariff-insight-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tariff-insight-number {
  font-size: 1.6rem;
  font-weight: 800;
}

/* Sections */
.tariff-section {
  padding: 24px;
}

.tariff-section-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 16px;
}

/* Table active row */
.tariff-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.tariff-row-active {
  background: rgba(235, 207, 152, 0.08) !important;
  outline: 2px solid rgba(235, 207, 152, 0.4);
  outline-offset: -2px;
  border-radius: 6px;
}

.tariff-current-tag {
  display: inline-block;
  font-size: 0.62rem;
  background: rgba(235, 207, 152, 0.2);
  color: rgba(235, 207, 152, 0.95);
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
  vertical-align: middle;
}

/* Retaliation grid */
.tariff-retaliation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}

.tariff-scenario-card {
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
}

.tariff-scenario-card h4 {
  margin: 0 0 6px;
  font-size: 0.88rem;
}

.tariff-scenario-desc {
  font-size: 0.78rem;
  color: var(--text-muted);
  margin: 0 0 10px;
  line-height: 1.5;
}

.tariff-scenario-numbers {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.82rem;
}

.tariff-scenario-card--danger {
  border-color: rgba(220, 38, 38, 0.25);
  background: rgba(220, 38, 38, 0.05);
}

/* Timeline */
.tariff-timeline {
  position: relative;
  padding-left: 28px;
}

.tariff-timeline::before {
  content: "";
  position: absolute;
  left: 8px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: var(--border-strong);
}

.tariff-timeline-item {
  position: relative;
  padding: 0 0 24px 16px;
}

.tariff-timeline-dot {
  position: absolute;
  left: -24px;
  top: 6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--accent);
  border: 2px solid var(--bg);
}

.tariff-timeline-date {
  font-size: 0.78rem;
  color: var(--accent);
  font-weight: 700;
}

.tariff-timeline-label {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 2px 0 6px;
}

.tariff-timeline-outcomes {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tariff-outcome-good,
.tariff-outcome-bad {
  display: inline-block;
  font-size: 0.76rem;
  padding: 3px 10px;
  border-radius: 6px;
}

.tariff-outcome-good {
  background: rgba(16, 185, 129, 0.1);
  color: var(--positive);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.tariff-outcome-bad {
  background: rgba(248, 113, 113, 0.1);
  color: var(--negative);
  border: 1px solid rgba(248, 113, 113, 0.2);
}

.tariff-methodology {
  padding: 16px 24px;
  font-size: 0.78rem;
  color: var(--text-muted);
  border-top: 1px solid var(--border);
  line-height: 1.6;
}

/* ═══════════════════════════════════════════════════════════════════════════
 * AUDIT TRAIL FIXES
 * ═══════════════════════════════════════════════════════════════════════════ */

.audit-wrap {
  position: relative;
  display: inline;
}

.audit-toggle-btn {
  min-width: 24px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.audit-panel {
  position: relative;
  z-index: 10;
  max-width: min(320px, 90vw);
}

/* ── Responsive ───────────────────────────────────────────────────────────── */
@media (max-width: 860px) {
  .export-bar { flex-wrap: wrap; }
  .metrics-summary-row { flex-direction: column; }
  .pipeline-stats-footer { flex-direction: column; align-items: center; }
  .pitch-cards-row { grid-template-columns: 1fr; }
  .pitch-cards-row--two { grid-template-columns: 1fr; }
  .pitch-pipeline { flex-direction: column; align-items: center; }
  .pitch-pipeline-arrow { transform: rotate(90deg); padding: 0; }
  .pitch-tier-diagram { grid-template-columns: 1fr; }
  .tariff-controls { flex-direction: column; }
  .tariff-retaliation-grid { grid-template-columns: 1fr; }
  .pitch-comparison-table td:first-child {
    position: sticky;
    left: 0;
    background: var(--bg);
    z-index: 1;
  }
}

/* ── Evidence Chain Panel ───────────────────────────────────────────────────── */
.evidence-chain-wrap {
  margin-top: 8px;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
}
.evidence-chain-toggle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 12px;
  background: var(--surface-soft);
  border: none;
  cursor: pointer;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-soft);
  gap: 8px;
}
.evidence-chain-toggle:hover { background: var(--bg-deep); }
.ec-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 400;
  color: var(--text-muted);
}
.ec-grade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
}
.ec-grade--a { background: #059669; }
.ec-grade--b { background: #3b82f6; }
.ec-grade--c { background: #f59e0b; }
.ec-grade--d { background: #ef4444; }
.evidence-chain-panel {
  padding: 12px;
  background: var(--surface);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ec-section { display: flex; flex-direction: column; gap: 6px; }
.ec-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-muted);
}
.ec-rubric-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 3px 12px; }
.ec-rubric-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: var(--text-soft);
}
.ec-rubric-row span:last-child { font-weight: 600; color: var(--text); }
.ec-gaps { font-size: 0.72rem; color: var(--negative); margin-top: 2px; }
.ec-tool-calls { display: flex; flex-direction: column; gap: 4px; }
.ec-tool-call {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.75rem;
  color: var(--text-soft);
}
.ec-tool-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: var(--accent);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
}
.ec-tool-name { font-weight: 600; color: var(--text); min-width: 90px; }
.ec-tool-preview { color: var(--text-muted); font-size: 0.72rem; line-height: 1.4; }
.ec-evidence-items { display: flex; flex-direction: column; gap: 8px; }
.ec-evidence-item {
  padding: 6px 8px;
  background: var(--surface-soft);
  border-left: 2px solid var(--accent);
  border-radius: 0 6px 6px 0;
}
.ec-ev-source { font-size: 0.68rem; font-weight: 700; color: var(--accent); }
.ec-ev-text {
  font-size: 0.75rem;
  color: var(--text-soft);
  margin: 3px 0 0;
  line-height: 1.45;
}
.ec-reflection {
  font-size: 0.73rem;
  color: var(--text-muted);
  font-style: italic;
  padding: 3px 0;
  border-bottom: 1px solid var(--border);
}
.ec-reflection:last-child { border-bottom: none; }
.ec-final-answer {
  font-size: 0.78rem;
  color: var(--text-soft);
  line-height: 1.5;
  padding: 8px;
  background: var(--surface-soft);
  border-radius: 6px;
}

/* ── LLM Chain Degradation Visual Comparison ─────────────────────────────── */
.chain-compare {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 24px;
  align-items: start;
  margin: 8px 0 24px;
}
.chain-col {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.chain-col-header {
  text-align: center;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 7px 14px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
}
.chain-col-header--bad {
  background: rgba(220, 38, 38, 0.08);
  color: var(--negative);
  border: 1px solid rgba(220, 38, 38, 0.18);
  border-bottom: none;
}
.chain-col-header--good {
  background: rgba(5, 150, 105, 0.08);
  color: var(--positive);
  border: 1px solid rgba(5, 150, 105, 0.18);
  border-bottom: none;
}
.chain-steps {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: 0 0 10px 10px;
  padding: 16px 14px 12px;
  background: var(--surface);
}
.chain-step-wrap {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.chain-connector {
  width: 2px;
  height: 14px;
  align-self: center;
}
.chain-connector--solid {
  background: var(--negative);
  opacity: 0.5;
}
.chain-connector--dotted {
  border-left: 2px dashed var(--positive);
  opacity: 0.5;
  background: none;
}
.chain-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  padding: 9px 11px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface-soft);
}
.chain-step--bad {
  border-color: rgba(220, 38, 38, 0.15);
}
.chain-step--good {
  border-color: rgba(5, 150, 105, 0.2);
  opacity: 1 !important;
}
.chain-step-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text);
  text-align: center;
  width: 100%;
}
.chain-step-acc {
  font-size: 0.72rem;
  font-weight: 700;
}
.chain-badges {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 2px;
}
.chain-badge {
  font-size: 0.62rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(5, 150, 105, 0.1);
  color: var(--positive);
  border: 1px solid rgba(5, 150, 105, 0.2);
}
.chain-verdict {
  margin-top: 10px;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  padding: 6px 10px;
  border-radius: 6px;
}
.chain-verdict--bad {
  color: var(--negative);
  background: rgba(220, 38, 38, 0.06);
}
.chain-verdict--good {
  color: var(--positive);
  background: rgba(5, 150, 105, 0.06);
}
.chain-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-muted);
  padding-top: 48px;
}
@media (max-width: 860px) {
  .chain-compare {
    grid-template-columns: 1fr;
  }
  .chain-divider {
    padding-top: 0;
    text-align: center;
  }
}

/* ── Chain Degradation Explainer ─────────────────────────────────────────── */
.chain-degradation-explainer {
  max-width: 780px;
  margin: 0 auto 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.chain-degradation-explainer p {
  font-size: 0.95rem;
  color: var(--text-soft);
  line-height: 1.7;
  text-align: center;
}
.chain-degradation-explainer strong {
  color: var(--text);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oEAAoE;EACpE,mEAAmE;EACnE,0EAA0E;EAC1E,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,yCAAyC;EACzC,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,mDAAmD;EACnD,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B;;;WAGS;EACT,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;;;;;EAME,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yHAAyH;EACzH,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB;iFAC+E;EAC/E,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB;;2CAEyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B;;0CAEwC;AAC1C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,uFAAuF;AACzF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;;AAGA;;;;EAIE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB;+HAC6H;AAC/H;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;EAKE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc,EAAE,UAAU;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;+EAI+E;;AAE/E,wEAAwE;AACxE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;AACA,0BAA0B,UAAU,EAAE;;AAEtC,yBAAyB;AACzB;EACE,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,sCAAsC;AACxC;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD,oBAAoB,wBAAwB,EAAE,mBAAmB,EAAE;AACnE,oBAAoB,iBAAiB,EAAE;AACvC,oBAAoB,wBAAwB,EAAE,eAAe,EAAE;;AAE/D,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;;+EAG+E;;AAE/E,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gFAAgF;AAChF;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mBAAmB,sBAAsB,EAAE;AAC3C,mBAAmB,sBAAsB,EAAE;AAC3C,mBAAmB,wBAAwB,EAAE;;AAE7C,gFAAgF;AAChF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;gFAEgF;;AAEhF;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,8EAA8E;EAC9E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa,sBAAsB,EAAE,gBAAgB,EAAE;AACvD,YAAY,sBAAsB,EAAE,YAAY,EAAE;AAClD,iBAAiB,qBAAqB,EAAE;;AAExC,eAAe;AACf,oBAAoB,eAAe,EAAE;;AAErC;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B,0BAA0B,EAAE;;AAEtD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,0BAA0B,aAAa,EAAE;;AAEzC;;gFAEgF;;AAEhF;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;gFAEgF;;AAEhF;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,gFAAgF;AAChF;EACE,cAAc,eAAe,EAAE;EAC/B,uBAAuB,sBAAsB,EAAE;EAC/C,yBAAyB,sBAAsB,EAAE,mBAAmB,EAAE;EACtE,mBAAmB,0BAA0B,EAAE;EAC/C,wBAAwB,0BAA0B,EAAE;EACpD,kBAAkB,sBAAsB,EAAE,mBAAmB,EAAE;EAC/D,wBAAwB,wBAAwB,EAAE,UAAU,EAAE;EAC9D,sBAAsB,0BAA0B,EAAE;EAClD,mBAAmB,sBAAsB,EAAE;EAC3C,2BAA2B,0BAA0B,EAAE;EACvD;IACE,gBAAgB;IAChB,OAAO;IACP,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;AACV;AACA,+BAA+B,0BAA0B,EAAE;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA,eAAe,mBAAmB,EAAE;AACpC,eAAe,mBAAmB,EAAE;AACpC,eAAe,mBAAmB,EAAE;AACpC,eAAe,mBAAmB,EAAE;AACpC;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,aAAa,EAAE;AAChF;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;AACzB;AACA,iCAAiC,gBAAgB,EAAE,kBAAkB,EAAE;AACvE,WAAW,kBAAkB,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACxE,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACvE,mBAAmB,wBAAwB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACnF,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACtE;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;AAC5B;AACA,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC5E;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;AACA,4BAA4B,mBAAmB,EAAE;AACjD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[":root {\n  color-scheme: light;\n  --font-sans: \"Inter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  --font-serif: \"Playfair Display\", Georgia, \"Times New Roman\", serif;\n  --font-mono: \"JetBrains Mono\", \"Menlo\", \"Monaco\", \"Courier New\", monospace;\n  --bg: #f0ebe4;\n  --bg-deep: #e6e0d8;\n  --surface: rgba(255, 255, 255, 0.92);\n  --surface-strong: rgba(255, 255, 255, 0.98);\n  --surface-soft: rgba(255, 255, 255, 0.75);\n  --border: rgba(0, 0, 0, 0.08);\n  --border-strong: rgba(0, 0, 0, 0.15);\n  --text: #0f0c29;\n  --text-soft: #3d3960;\n  --text-muted: #7c78a0;\n  --accent: #2b4a5c;\n  --accent-strong: #1e3a4a;\n  --accent-soft: #4a6b7d;\n  --accent-wash: rgba(43, 74, 92, 0.08);\n  --accent-wash-2: rgba(43, 74, 92, 0.14);\n  --positive: #059669;\n  --negative: #dc2626;\n  --complex: #d97706;\n  --panel-shadow: 0 4px 24px rgba(0, 0, 0, 0.09);\n  --shadow-button: 0 10px 24px rgba(30, 58, 74, 0.28);\n  --shadow-active-tab: 0 2px 8px rgba(30, 58, 74, 0.26);\n  --gradient-analyze: linear-gradient(135deg, #3a5f72, #1e3a4a);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  background:\n    radial-gradient(ellipse at top left, rgba(43, 74, 92, 0.07), transparent 45%),\n    radial-gradient(ellipse at bottom right, rgba(43, 74, 92, 0.05), transparent 40%),\n    #f0ebe4;\n  color: var(--text);\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.app-shell {\n  position: relative;\n  min-height: 100vh;\n  padding: 60px 28px 128px;\n}\n\n.ambient-orb {\n  position: fixed;\n  z-index: 0;\n  width: 24rem;\n  height: 24rem;\n  border-radius: 999px;\n  filter: blur(92px);\n  opacity: 0.28;\n  pointer-events: none;\n}\n\n.ambient-orb-left {\n  top: -6rem;\n  left: -8rem;\n  background: rgba(43, 74, 92, 0.12);\n}\n\n.ambient-orb-right {\n  right: -8rem;\n  bottom: 5rem;\n  background: rgba(43, 74, 92, 0.08);\n}\n\n.masthead,\n.notice-banner,\n.control-deck,\n.tab-row,\n.content-frame,\n.summary-ribbon {\n  position: relative;\n  z-index: 1;\n}\n\n.masthead {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px;\n  align-items: start;\n  margin: 0 auto 34px;\n  max-width: 1480px;\n}\n\n.masthead-copy {\n  display: grid;\n  justify-items: center;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.eyebrow,\n.panel-kicker {\n  font-family: var(--font-sans);\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--accent);\n  font-size: 0.72rem;\n}\n\n.masthead h1 {\n  margin: 0 auto;\n  font-family: var(--font-serif);\n  max-width: 19ch;\n  font-size: clamp(2rem, 4.2vw, 4rem);\n  line-height: 1.03;\n  letter-spacing: -0.01em;\n  font-weight: 800;\n  color: var(--text);\n}\n\n.masthead h1.ripple-logo {\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.masthead h1.ripple-logo:hover {\n  opacity: 0.85;\n}\n\n.masthead h1 span {\n  color: var(--accent);\n}\n\n.masthead-subtitle {\n  margin-top: 8px;\n  color: var(--text-soft);\n  font-size: 1.25rem;\n}\n\n.home-button {\n  background: rgba(0, 119, 204, 0.12);\n  border: 1px solid rgba(0, 119, 204, 0.3);\n  color: #0077cc;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.home-button:hover {\n  background: rgba(0, 119, 204, 0.2);\n  border-color: rgba(0, 119, 204, 0.5);\n}\n\n.masthead-subsection {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  color: var(--text-soft);\n  font-size: 0.96rem;\n  justify-self: center;\n}\n\n.masthead-subsection span {\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  font-size: 0.72rem;\n}\n\n.portfolio-ticker-row {\n  letter-spacing: 0.01em;\n}\n\n.portfolio-separator {\n  color: var(--text-muted);\n}\n\n.meta-pill {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid var(--border);\n  box-shadow: var(--panel-shadow);\n  backdrop-filter: blur(16px);\n}\n\n.meta-pill span {\n  color: var(--text-muted);\n  font-size: 0.84rem;\n}\n\n.meta-pill strong {\n  text-align: right;\n  font-size: 0.92rem;\n}\n\n.meta-live {\n  border-color: rgba(103, 168, 127, 0.28);\n}\n\n.meta-mock {\n  border-color: rgba(201, 181, 138, 0.28);\n}\n\n.notice-banner {\n  max-width: 1480px;\n  margin: 0 auto 32px;\n  padding: 14px 18px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid var(--border);\n  color: var(--text-soft);\n}\n\n.notice-below-controls {\n  margin-top: 28px;\n}\n\n.control-deck,\n.tab-row,\n.panel-surface,\n.effect-graph-shell,\n.summary-ribbon {\n  max-width: 1480px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.control-cluster {\n  width: min(100%, 1480px);\n  margin: 0 auto 30px;\n}\n\n.content-frame {\n  display: grid;\n  gap: 28px;\n}\n\n.graph-top-section {\n  display: grid;\n  gap: 28px;\n}\n\n.content-frame > * {\n  width: min(100%, 1480px);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.control-deck {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.25fr) repeat(2, minmax(112px, 0.6fr)) minmax(180px, 1fr) minmax(220px, 1.2fr) auto;\n  gap: 14px;\n  padding: 22px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid var(--border);\n  box-shadow: var(--panel-shadow);\n  backdrop-filter: blur(16px);\n  margin-bottom: 0;\n}\n\n.control-callout {\n  display: grid;\n  justify-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.control-callout-button {\n  border: none;\n  padding: 13px 24px;\n  border-radius: 999px;\n  background:\n    linear-gradient(135deg, rgba(241, 214, 161, 0.98), rgba(201, 181, 138, 0.98));\n  color: #142033;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  box-shadow:\n    0 14px 28px rgba(9, 14, 22, 0.16),\n    inset 0 1px 0 rgba(255, 255, 255, 0.45);\n}\n\n.control-callout-button:hover {\n  transform: translateY(-1px);\n  box-shadow:\n    0 16px 30px rgba(9, 14, 22, 0.18),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.control-callout-link {\n  width: 2px;\n  height: 22px;\n  border-radius: 999px;\n  background: linear-gradient(180deg, rgba(235, 207, 152, 0.9), rgba(201, 181, 138, 0.1));\n}\n\n.control-group {\n  display: grid;\n  gap: 8px;\n}\n\n.control-group label {\n  font-family: var(--font-sans);\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n}\n\n.control-group select,\n.control-group input,\n.surface-actions input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid var(--border-strong);\n  color: var(--text);\n  box-shadow: none;\n  font-size: 1rem;\n}\n\n.compact input {\n  min-width: 0;\n}\n\n.slider-group .slider-shell {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 14px;\n  align-items: center;\n}\n\n.slider-shell input[type=\"range\"] {\n  padding: 0;\n}\n\n.slider-shell strong {\n  font-family: var(--font-sans);\n}\n\n.analyze-button {\n  align-self: end;\n  padding: 14px 22px;\n  border: none;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #3a5f72, #1e3a4a);\n  color: #ffffff;\n  font-weight: 700;\n  min-height: 52px;\n  font-size: 1rem;\n  box-shadow: 0 10px 24px rgba(30, 58, 74, 0.28);\n}\n\n.analyze-button:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.tab-row {\n  display: flex;\n  gap: 6px;\n  width: fit-content;\n  max-width: 100%;\n  margin-top: 12px;\n  margin-bottom: 34px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 8px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--border);\n}\n\n.tab {\n  border: none;\n  padding: 11px 14px;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.tab.active {\n  background: var(--accent);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(43, 74, 92, 0.28);\n}\n\n.effect-graph-shell {\n  display: grid;\n  grid-template-columns: 240px 1fr 340px;\n  gap: 24px;\n}\n\n\n.graph-stage,\n.graph-detail-panel,\n.roster-panel,\n.panel-surface {\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: var(--panel-shadow);\n  backdrop-filter: blur(16px);\n}\n\n.custom-panel {\n  padding: 24px;\n  overflow-y: auto;\n  max-height: 680px;\n}\n\n.graph-stage {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  min-height: 680px;\n  overflow: hidden;\n}\n\n.graph-toolbar,\n.graph-footer {\n  display: flex;\n  justify-content: space-between;\n  gap: 18px;\n  align-items: center;\n  padding: 18px 22px;\n}\n\n.graph-toggle,\n.graph-slider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-soft);\n  font-size: 0.88rem;\n}\n\n.graph-slider input[type=\"range\"] {\n  width: 120px;\n}\n\n.graph-slider strong,\n.graph-footer span,\n.panel-stat-card strong,\n.summary-list strong {\n  font-family: var(--font-sans);\n}\n\n.graph-canvas-wrap {\n  min-height: 600px;\n  background:\n    radial-gradient(ellipse at center, rgba(230, 235, 245, 0.9) 0%, rgba(220, 228, 240, 0.95) 66%, rgba(210, 220, 235, 1) 100%);\n}\n\n.graph-canvas {\n  width: 100%;\n  height: 100%;\n  min-height: 600px;\n  display: block;\n}\n\n.graph-footer {\n  border-top: 1px solid var(--border);\n  color: var(--text-muted);\n  font-size: 0.82rem;\n}\n\n.graph-detail-panel {\n  overflow: hidden;\n}\n\n.graph-panel-body {\n  padding: 24px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.panel-title {\n  margin: 10px 0 8px;\n  font-family: var(--font-sans);\n  font-size: 1.68rem;\n}\n\n.panel-copy {\n  margin: 0;\n  color: var(--text-soft);\n  line-height: 1.6;\n}\n\n.panel-copy.strong {\n  color: var(--text);\n}\n\n.panel-section {\n  margin-top: 22px;\n}\n\n.inline-heading {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: baseline;\n}\n\n.inline-hint {\n  color: var(--text-muted);\n  font-size: 0.82rem;\n}\n\n.panel-section-title {\n  margin: 0 0 12px;\n  color: var(--text);\n  font-size: 0.96rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.panel-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.panel-stat-card,\n.effect-card,\n.mini-case-card,\n.case-card,\n.evidence-card,\n.empty-state-card,\n.selector-card {\n  border-radius: 18px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n}\n\n.panel-stat-card {\n  display: grid;\n  gap: 6px;\n  padding: 14px;\n}\n\n.panel-stat-label {\n  color: var(--text-muted);\n  font-size: 0.78rem;\n}\n\n.roster-list,\n.selector-grid {\n  display: grid;\n  gap: 10px;\n}\n\n.roster-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-start;\n  padding: 11px 13px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.8);\n  color: var(--text-soft);\n}\n\n.roster-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n}\n\n.summary-list {\n  display: grid;\n  gap: 10px;\n}\n\n.summary-list.compact {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.summary-list div {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.summary-list span {\n  color: var(--text-muted);\n}\n\n.signal-list,\n.effect-list,\n.case-card-stack {\n  display: grid;\n  gap: 12px;\n}\n\n.signal-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--border);\n}\n\n.signal-metric {\n  color: var(--text-soft);\n}\n\n.effect-card,\n.mini-case-card,\n.case-card {\n  padding: 16px;\n}\n\n.effect-card p,\n.mini-case-card p,\n.case-card p {\n  margin: 0;\n  color: var(--text-soft);\n  line-height: 1.55;\n}\n\n.effect-card-head,\n.case-card-topline,\n.case-card-stats,\n.case-card-foot,\n.mini-case-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.effect-card-head,\n.case-card-topline,\n.mini-case-header {\n  margin-bottom: 10px;\n  align-items: center;\n}\n\n.effect-card-confidence,\n.case-card-topline span,\n.case-card-stats span,\n.case-card-foot span,\n.mini-case-header span {\n  color: var(--text-muted);\n  font-size: 0.82rem;\n}\n\n.case-card-stats,\n.case-card-foot {\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.case-counterexample {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 107, 92, 0.08);\n  color: #ffb2a7;\n  font-size: 0.86rem;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.2rem;\n  padding: 5px 9px;\n  border-radius: 999px;\n  font-family: var(--font-sans);\n  font-size: 0.68rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.badge-l1 {\n  background: rgba(5, 150, 105, 0.1);\n  color: #047857;\n}\n\n.badge-l2 {\n  background: rgba(59, 130, 246, 0.12);\n  color: #1d4ed8;\n}\n\n.badge-l3 {\n  background: rgba(43, 74, 92, 0.12);\n  color: #1e3a4a;\n}\n\n.content-frame {\n  min-height: 720px;\n}\n\n.panel-surface {\n  padding: 24px;\n}\n\n.surface-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 18px;\n  align-items: start;\n  margin-bottom: 22px;\n}\n\n.surface-header h2 {\n  margin: 10px 0 0;\n  font-family: var(--font-serif);\n  font-size: 2rem;\n}\n\n.surface-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.surface-actions button {\n  padding: 11px 14px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid var(--border-strong);\n  color: var(--text);\n}\n\n.surface-actions button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.input-actions {\n  min-width: min(100%, 340px);\n}\n\n.brief-block {\n  margin: 0;\n  padding: 24px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid var(--border);\n  color: var(--text);\n  overflow: auto;\n  white-space: pre-wrap;\n  font-family: var(--font-sans);\n  line-height: 1.6;\n}\n\n.filter-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.filter-strip span {\n  padding: 10px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--border);\n  color: var(--text-soft);\n}\n\n.selector-card {\n  display: grid;\n  gap: 6px;\n  padding: 16px;\n  text-align: left;\n  color: var(--text-soft);\n}\n\n.selector-card strong {\n  color: var(--text);\n}\n\n.empty-surface-copy {\n  padding: 20px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--border);\n  color: var(--text-soft);\n}\n\n.case-card-grid,\n.raw-grid {\n  display: grid;\n  gap: 18px;\n}\n\n.raw-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.raw-column h3 {\n  margin-top: 0;\n  margin-bottom: 14px;\n  font-size: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.summary-ribbon {\n  position: fixed;\n  left: 28px;\n  right: 28px;\n  bottom: 18px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 14px 18px;\n  border-radius: 16px;\n  background: rgba(24, 35, 51, 0.94);\n  border: 1px solid rgba(201, 181, 138, 0.14);\n  backdrop-filter: blur(18px);\n  color: var(--text-soft);\n}\n\n.mock-footer-status {\n  text-align: center;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 12px;\n  margin: 40px auto 0;\n  max-width: 1480px;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n}\n\n.status-connected {\n  color: #10b981; /* Green */\n}\n\n/* Roster Sidebar Styles */\n.roster-panel {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.roster-heading {\n  margin: 0 0 16px;\n  font-size: 0.8rem;\n  letter-spacing: 0.05em;\n  color: var(--text-muted);\n  text-transform: uppercase;\n}\n\n.roster-list-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.roster-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  color: var(--text);\n  transition: all 0.2s;\n  text-align: left;\n}\n\n.roster-item:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.roster-item.selected {\n  background: rgba(43, 74, 92, 0.08);\n  border-color: rgba(43, 74, 92, 0.2);\n}\n\n.roster-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* Switch styling */\n.switch-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  color: #dce4ee;\n}\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 20px;\n}\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.slider.round {\n  position: absolute;\n  cursor: pointer;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: #334155;\n  transition: .4s;\n  border-radius: 34px;\n}\n.slider.round:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\ninput:checked + .slider.round {\n  background-color: #ebcf98;\n}\ninput:checked + .slider.round:before {\n  transform: translateX(16px);\n  background-color: #122033;\n}\n\n/* Progress bars */\n.progress-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  font-size: 0.85rem;\n  color: #dce4ee;\n}\n.progress-row span {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n.progress-track {\n  height: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n  overflow: hidden;\n}\n.progress-fill {\n  height: 100%;\n  background: rgba(135, 206, 235, 0.8);\n  border-radius: 3px;\n}\n\n/* ── Audit Trail ──────────────────────────────────────────────────────────────\n   These styles power the ⓘ expand buttons and the panels they reveal.\n   The design philosophy: subtle by default (low-opacity gold ⓘ), rich on click.\n   Everything uses existing CSS variables so it auto-fits the dark theme.\n   ────────────────────────────────────────────────────────────────────────── */\n\n/* Wrapper keeps the button and the expanding panel stacked vertically */\n.audit-wrap {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n/* The ⓘ button itself — small, gold, unobtrusive */\n.audit-toggle-btn {\n  background: none;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  font-size: 11px;\n  padding: 0 2px;\n  opacity: 0.65;\n  transition: opacity 0.15s;\n  line-height: 1;\n  vertical-align: middle;\n}\n.audit-toggle-btn:hover { opacity: 1; }\n\n/* The expandable panel */\n.audit-panel {\n  background: rgba(255, 255, 255, 0.97);\n  border: 1px solid var(--border-strong);\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-top: 6px;\n  font-size: 11px;\n  line-height: 1.7;\n  min-width: 210px;\n  max-width: 300px;\n  color: var(--text-soft);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  white-space: normal;\n}\n\n/* Section header inside the panel */\n.audit-section-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--accent);\n  margin-bottom: 6px;\n}\n\n/* Each row: label on the left, value on the right */\n.audit-step {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 2px 0;\n  border-bottom: 1px solid var(--border);\n}\n.audit-step:last-of-type { border-bottom: none; }\n\n.audit-step-label { color: var(--text-muted); white-space: nowrap; }\n.audit-step-value { text-align: right; }\n.audit-step-note  { color: var(--text-muted); font-size: 10px; }\n\n/* Monospace formula line — makes the arithmetic readable at a glance */\n.audit-formula {\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  color: var(--accent);\n  background: rgba(43, 74, 92, 0.07);\n  border-radius: 4px;\n  padding: 4px 6px;\n  margin: 6px 0 4px;\n  word-break: break-all;\n}\n\n/* Source citation — italicised, muted */\n.audit-source {\n  font-size: 10px;\n  color: var(--text-muted);\n  font-style: italic;\n  margin-top: 4px;\n}\n\n/* ── Material Change List (node detail panel) ─────────────────────────────── */\n.material-change-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Each row: metric name left, arrow + % + optional ⓘ right */\n.material-change-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n  gap: 12px;\n}\n\n.material-change-metric {\n  color: var(--text-soft);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.material-change-value {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n@media (max-width: 1200px) {\n  .masthead,\n  .effect-graph-shell,\n  .control-deck,\n  .raw-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .graph-stage {\n    min-height: 640px;\n  }\n\n  .graph-canvas-wrap,\n  .graph-canvas {\n    min-height: 560px;\n  }\n}\n\n@media (max-width: 860px) {\n  .app-shell {\n    padding: 32px 16px 96px;\n  }\n\n  .control-deck {\n    grid-template-columns: 1fr;\n  }\n\n  .control-callout {\n    margin-bottom: 12px;\n  }\n\n  .graph-toolbar,\n  .surface-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .tab-row {\n    overflow-x: auto;\n  }\n\n  .summary-ribbon {\n    left: 16px;\n    right: 16px;\n    bottom: 12px;\n  }\n}\n\n/* ══════════════════════════════════════════════════════════════════════════════\n   FINANCIAL METRICS TAB + EXPORT BAR + PIPELINE FOOTER\n   Added for mentor demo — all new classes, no overrides.\n   ══════════════════════════════════════════════════════════════════════════ */\n\n/* ── Export bar in masthead ────────────────────────────────────────────────── */\n.export-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.export-bar-label {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--text-muted);\n  margin-right: 4px;\n}\n\n.export-button {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: rgba(43, 74, 92, 0.08);\n  border: 1px solid rgba(43, 74, 92, 0.2);\n  color: var(--accent);\n  font-size: 0.82rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background 0.15s;\n}\n\n.export-button:hover {\n  background: rgba(43, 74, 92, 0.16);\n  color: var(--accent-strong);\n}\n\n/* ── Pipeline stats footer ────────────────────────────────────────────────── */\n.pipeline-stats-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 14px;\n  padding: 18px;\n  margin: 40px auto 0;\n  max-width: 1480px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n}\n\n.stat-pill {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 18px;\n}\n\n.stat-pill strong {\n  font-size: 1.1rem;\n  color: var(--text);\n  font-family: var(--font-sans);\n}\n\n.stat-pill span {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n/* ── Metrics tab ──────────────────────────────────────────────────────────── */\n.metrics-surface {\n  padding: 28px;\n}\n\n.metrics-surface h2 {\n  margin: 8px 0 0;\n  font-family: var(--font-sans);\n  font-size: 1.8rem;\n}\n\n.metrics-company-select {\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid var(--border-strong);\n  color: var(--text);\n  font-size: 0.88rem;\n}\n\n/* ── Anomaly alerts ───────────────────────────────────────────────────────── */\n.anomaly-strip {\n  display: grid;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.anomaly-card {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: rgba(248, 113, 113, 0.06);\n  border: 1px solid rgba(248, 113, 113, 0.15);\n}\n\n.anomaly-card.anomaly-divergence {\n  background: rgba(251, 191, 36, 0.06);\n  border-color: rgba(251, 191, 36, 0.15);\n}\n\n.anomaly-icon {\n  font-size: 1.2rem;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.anomaly-card strong {\n  color: var(--text);\n  font-size: 0.9rem;\n}\n\n.anomaly-card p {\n  margin: 4px 0 0;\n  color: var(--text-soft);\n  font-size: 0.86rem;\n  line-height: 1.5;\n}\n\n/* ── Company pills row ────────────────────────────────────────────────────── */\n.metrics-summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 28px;\n}\n\n.metrics-company-pill {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  padding: 12px 18px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--border);\n  color: var(--text-soft);\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.metrics-company-pill:hover {\n  border-color: var(--border-strong);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.metrics-company-pill.active {\n  border-color: var(--accent);\n  background: rgba(43, 74, 92, 0.08);\n}\n\n.metrics-company-pill strong {\n  font-size: 1rem;\n  color: var(--text);\n}\n\n.metrics-company-pill span {\n  font-size: 0.74rem;\n  color: var(--text-muted);\n}\n\n/* ── Metric group + table ─────────────────────────────────────────────────── */\n.metrics-group {\n  margin-bottom: 28px;\n}\n\n.metrics-group-title {\n  margin: 0 0 12px;\n  font-size: 0.82rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n}\n\n.metrics-table-wrap {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n}\n\n.metrics-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1rem;\n}\n\n.metrics-table th {\n  padding: 10px 14px;\n  text-align: right;\n  font-weight: 600;\n  color: var(--text-muted);\n  font-size: 0.88rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid var(--border);\n}\n\n.metrics-table th:first-child {\n  text-align: left;\n}\n\n.metrics-subheader th {\n  font-size: 0.68rem;\n  padding: 6px 14px;\n  color: var(--text-muted);\n  opacity: 0.7;\n}\n\n.metrics-table td {\n  padding: 10px 14px;\n  text-align: right;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n  color: var(--text-soft);\n}\n\n.metric-name {\n  text-align: left !important;\n  color: var(--text) !important;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.metric-value.dim,\n.metric-change.dim {\n  color: var(--text-muted);\n  opacity: 0.5;\n}\n\n.metric-alert {\n  font-weight: 600;\n}\n\n.metric-alert-dot {\n  margin-left: 4px;\n  color: var(--negative);\n  font-size: 0.78rem;\n}\n\n.change-positive { color: var(--positive); }\n.change-negative { color: var(--negative); }\n.change-neutral  { color: var(--text-muted); }\n\n/* ── Methodology footnote ─────────────────────────────────────────────────── */\n.metrics-methodology {\n  margin-top: 28px;\n  padding: 14px 18px;\n  border-radius: 10px;\n  background: var(--surface-soft);\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  font-size: 0.82rem;\n  line-height: 1.6;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n * PITCH VIEW\n * ═══════════════════════════════════════════════════════════════════════════ */\n\n.pitch-root {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.pitch-section {\n  padding: 56px 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n.pitch-section--alt {\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 20px;\n  margin: 8px 0;\n  border: 1px solid var(--border);\n}\n\n.pitch-section-title {\n  font-family: var(--font-serif);\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  margin: 0 0 28px;\n  text-align: center;\n}\n\n/* Hero */\n.pitch-hero {\n  text-align: center;\n  padding: 80px 24px 64px;\n}\n\n.pitch-hero-title {\n  font-size: clamp(2.4rem, 5vw, 4.2rem);\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  margin: 0;\n  background: linear-gradient(135deg, #f0f2f5 0%, rgba(235, 207, 152, 0.9) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.pitch-hero-subtitle {\n  font-size: 1.15rem;\n  color: var(--text-soft);\n  margin: 8px 0 0;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.pitch-hero-tagline {\n  font-size: 1.05rem;\n  color: var(--text-muted);\n  margin: 24px auto 0;\n  max-width: 540px;\n  line-height: 1.65;\n  font-style: italic;\n}\n\n.pitch-hero-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-top: 32px;\n  flex-wrap: wrap;\n}\n\n.pitch-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 24px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #3a5f72, #1e3a4a);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.92rem;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.15s, box-shadow 0.15s;\n  text-decoration: none;\n}\n\n.pitch-cta:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(30, 58, 74, 0.4);\n}\n\n.pitch-cta-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 24px;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-soft);\n  font-weight: 600;\n  font-size: 0.92rem;\n  border: 1px solid var(--border-strong);\n  cursor: pointer;\n  text-decoration: none;\n  transition: border-color 0.15s;\n}\n\n.pitch-cta-secondary:hover {\n  border-color: var(--accent);\n  color: #fff;\n}\n\n/* Cards row */\n.pitch-cards-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.pitch-cards-row--two {\n  grid-template-columns: repeat(2, 1fr);\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.pitch-cards-row--market {\n  grid-template-columns: repeat(2, 1fr);\n  max-width: 1040px;\n  margin: 0 auto;\n}\n\n.pitch-card {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n}\n\n.pitch-card h3 {\n  font-size: 1.2rem;\n  margin: 0 0 10px;\n  color: var(--text);\n}\n\n.pitch-card p {\n  font-size: 1rem;\n  color: var(--text-soft);\n  line-height: 1.6;\n  margin: 0 0 8px;\n}\n\n.pitch-card ul {\n  margin: 8px 0 0;\n  padding-left: 18px;\n  font-size: 0.86rem;\n  color: var(--text-soft);\n  line-height: 1.7;\n}\n\n.pitch-card--stat {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Pipeline diagram */\n.pitch-pipeline {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  overflow-x: auto;\n  padding: 12px 0;\n}\n\n.pitch-pipeline-step {\n  flex: 1;\n  min-width: 140px;\n  background: var(--surface-strong);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 18px 14px;\n  text-align: center;\n}\n\n.pitch-pipeline-step--final {\n  border-color: var(--accent);\n  background: rgba(43, 74, 92, 0.06);\n}\n\n.pitch-step-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: #fff;\n  font-size: 0.8rem;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.pitch-pipeline-step h4 {\n  font-size: 0.82rem;\n  margin: 0 0 6px;\n  color: var(--text);\n}\n\n.pitch-pipeline-step p {\n  font-size: 0.76rem;\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.pitch-pipeline-arrow {\n  display: flex;\n  align-items: center;\n  color: var(--text-muted);\n  font-size: 1.2rem;\n  padding-top: 30px;\n  flex-shrink: 0;\n}\n\n/* Stat bar */\n.pitch-stat-bar {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  margin-top: 32px;\n  flex-wrap: wrap;\n}\n\n.pitch-stat {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pitch-stat-number {\n  font-size: 2rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(235, 207, 152, 0.95);\n}\n\n.pitch-stat-label {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n/* Comparison table */\n.pitch-table-wrap {\n  overflow-x: auto;\n}\n\n.pitch-comparison-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.86rem;\n}\n\n.pitch-comparison-table th,\n.pitch-comparison-table td {\n  padding: 10px 14px;\n  text-align: center;\n  border-bottom: 1px solid var(--border);\n}\n\n.pitch-comparison-table th {\n  background: var(--surface-strong);\n  color: var(--text-soft);\n  font-weight: 600;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.pitch-comparison-table td:first-child {\n  text-align: left;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.pitch-comparison-table tbody tr:nth-child(even) {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.pitch-highlight-col {\n  background: rgba(43, 74, 92, 0.08) !important;\n  color: var(--accent) !important;\n}\n\n.pitch-symbol-cell {\n  font-size: 1.45rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.pitch-yes { color: var(--positive); font-weight: 600; }\n.pitch-no { color: var(--negative); opacity: 0.6; }\n.pitch-partial { color: var(--complex); }\n\n/* Expandable */\n.pitch-expandable { margin-top: 8px; }\n\n.pitch-expanded {\n  margin-top: 16px;\n  animation: pitch-fade-in 0.3s ease;\n}\n\n.pitch-expand-btn {\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 6px 0;\n  margin-top: 8px;\n}\n\n.pitch-expand-btn:hover { text-decoration: underline; }\n\n.pitch-body {\n  font-size: 1.05rem;\n  color: var(--text-soft);\n  line-height: 1.65;\n  margin: 0;\n}\n\n@keyframes pitch-fade-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Tier diagram */\n.pitch-tier-diagram {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.pitch-tier {\n  border-radius: 14px;\n  padding: 20px;\n  border: 1px solid var(--border);\n}\n\n.pitch-tier h4 {\n  margin: 0 0 8px;\n  font-size: 0.9rem;\n}\n\n.pitch-tier p {\n  font-size: 0.82rem;\n  color: var(--text-soft);\n  margin: 0 0 8px;\n}\n\n.pitch-tier ul {\n  margin: 0;\n  padding-left: 16px;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  line-height: 1.7;\n}\n\n.pitch-tier--high {\n  background: rgba(16, 185, 129, 0.06);\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.pitch-tier--low {\n  background: rgba(245, 158, 11, 0.06);\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n/* Footer */\n.pitch-footer-section {\n  text-align: center;\n  border-bottom: none;\n}\n\n.pitch-footer-quote {\n  font-size: 1.15rem;\n  font-style: italic;\n  color: var(--accent);\n  margin: 0 0 24px;\n}\n\n.pitch-footer-credits {\n  font-size: 0.88rem;\n  color: var(--text-soft);\n  line-height: 1.7;\n}\n\n.pitch-footer-credits p { margin: 2px 0; }\n\n/* ═══════════════════════════════════════════════════════════════════════════\n * TARIFF VIEW\n * ═══════════════════════════════════════════════════════════════════════════ */\n\n.tariff-surface {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tariff-controls {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  padding: 20px 24px;\n  background: var(--surface-strong);\n  border-radius: 14px;\n  margin: 16px 24px;\n  align-items: flex-end;\n}\n\n.tariff-control-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 160px;\n}\n\n.tariff-control-group label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n\n.tariff-control-group select,\n.tariff-control-group input[type=\"number\"] {\n  padding: 8px 12px;\n  background: var(--bg);\n  border: 1px solid var(--border-strong);\n  border-radius: 8px;\n  color: var(--text);\n  font-size: 1rem;\n}\n\n.tariff-rate-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tariff-rate-input input {\n  width: 72px;\n}\n\n.tariff-rate-input span {\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.tariff-slider {\n  width: 100%;\n  accent-color: var(--accent);\n  margin-top: 4px;\n}\n\n/* Insight bar */\n.tariff-insight-bar {\n  display: flex;\n  gap: 24px;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 20px;\n  margin: 0 24px;\n  background: rgba(248, 113, 113, 0.06);\n  border: 1px solid rgba(248, 113, 113, 0.15);\n  border-radius: 14px;\n}\n\n.tariff-insight {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tariff-insight-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.tariff-insight-number {\n  font-size: 1.6rem;\n  font-weight: 800;\n}\n\n/* Sections */\n.tariff-section {\n  padding: 24px;\n}\n\n.tariff-section-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0 0 16px;\n}\n\n/* Table active row */\n.tariff-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.tariff-row-active {\n  background: rgba(235, 207, 152, 0.08) !important;\n  outline: 2px solid rgba(235, 207, 152, 0.4);\n  outline-offset: -2px;\n  border-radius: 6px;\n}\n\n.tariff-current-tag {\n  display: inline-block;\n  font-size: 0.62rem;\n  background: rgba(235, 207, 152, 0.2);\n  color: rgba(235, 207, 152, 0.95);\n  padding: 1px 6px;\n  border-radius: 4px;\n  margin-left: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 700;\n  vertical-align: middle;\n}\n\n/* Retaliation grid */\n.tariff-retaliation-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n.tariff-scenario-card {\n  background: var(--surface-strong);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.tariff-scenario-card h4 {\n  margin: 0 0 6px;\n  font-size: 0.88rem;\n}\n\n.tariff-scenario-desc {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  margin: 0 0 10px;\n  line-height: 1.5;\n}\n\n.tariff-scenario-numbers {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 0.82rem;\n}\n\n.tariff-scenario-card--danger {\n  border-color: rgba(220, 38, 38, 0.25);\n  background: rgba(220, 38, 38, 0.05);\n}\n\n/* Timeline */\n.tariff-timeline {\n  position: relative;\n  padding-left: 28px;\n}\n\n.tariff-timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  bottom: 8px;\n  width: 2px;\n  background: var(--border-strong);\n}\n\n.tariff-timeline-item {\n  position: relative;\n  padding: 0 0 24px 16px;\n}\n\n.tariff-timeline-dot {\n  position: absolute;\n  left: -24px;\n  top: 6px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--accent);\n  border: 2px solid var(--bg);\n}\n\n.tariff-timeline-date {\n  font-size: 0.78rem;\n  color: var(--accent);\n  font-weight: 700;\n}\n\n.tariff-timeline-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 2px 0 6px;\n}\n\n.tariff-timeline-outcomes {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tariff-outcome-good,\n.tariff-outcome-bad {\n  display: inline-block;\n  font-size: 0.76rem;\n  padding: 3px 10px;\n  border-radius: 6px;\n}\n\n.tariff-outcome-good {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--positive);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.tariff-outcome-bad {\n  background: rgba(248, 113, 113, 0.1);\n  color: var(--negative);\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.tariff-methodology {\n  padding: 16px 24px;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  border-top: 1px solid var(--border);\n  line-height: 1.6;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n * AUDIT TRAIL FIXES\n * ═══════════════════════════════════════════════════════════════════════════ */\n\n.audit-wrap {\n  position: relative;\n  display: inline;\n}\n\n.audit-toggle-btn {\n  min-width: 24px;\n  min-height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.audit-panel {\n  position: relative;\n  z-index: 10;\n  max-width: min(320px, 90vw);\n}\n\n/* ── Responsive ───────────────────────────────────────────────────────────── */\n@media (max-width: 860px) {\n  .export-bar { flex-wrap: wrap; }\n  .metrics-summary-row { flex-direction: column; }\n  .pipeline-stats-footer { flex-direction: column; align-items: center; }\n  .pitch-cards-row { grid-template-columns: 1fr; }\n  .pitch-cards-row--two { grid-template-columns: 1fr; }\n  .pitch-pipeline { flex-direction: column; align-items: center; }\n  .pitch-pipeline-arrow { transform: rotate(90deg); padding: 0; }\n  .pitch-tier-diagram { grid-template-columns: 1fr; }\n  .tariff-controls { flex-direction: column; }\n  .tariff-retaliation-grid { grid-template-columns: 1fr; }\n  .pitch-comparison-table td:first-child {\n    position: sticky;\n    left: 0;\n    background: var(--bg);\n    z-index: 1;\n  }\n}\n\n/* ── Evidence Chain Panel ───────────────────────────────────────────────────── */\n.evidence-chain-wrap {\n  margin-top: 8px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.evidence-chain-toggle {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px 12px;\n  background: var(--surface-soft);\n  border: none;\n  cursor: pointer;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-soft);\n  gap: 8px;\n}\n.evidence-chain-toggle:hover { background: var(--bg-deep); }\n.ec-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 400;\n  color: var(--text-muted);\n}\n.ec-grade {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #fff;\n}\n.ec-grade--a { background: #059669; }\n.ec-grade--b { background: #3b82f6; }\n.ec-grade--c { background: #f59e0b; }\n.ec-grade--d { background: #ef4444; }\n.evidence-chain-panel {\n  padding: 12px;\n  background: var(--surface);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.ec-section { display: flex; flex-direction: column; gap: 6px; }\n.ec-section-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-muted);\n}\n.ec-rubric-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 3px 12px; }\n.ec-rubric-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.75rem;\n  color: var(--text-soft);\n}\n.ec-rubric-row span:last-child { font-weight: 600; color: var(--text); }\n.ec-gaps { font-size: 0.72rem; color: var(--negative); margin-top: 2px; }\n.ec-tool-calls { display: flex; flex-direction: column; gap: 4px; }\n.ec-tool-call {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.75rem;\n  color: var(--text-soft);\n}\n.ec-tool-icon {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  background: var(--accent);\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n}\n.ec-tool-name { font-weight: 600; color: var(--text); min-width: 90px; }\n.ec-tool-preview { color: var(--text-muted); font-size: 0.72rem; line-height: 1.4; }\n.ec-evidence-items { display: flex; flex-direction: column; gap: 8px; }\n.ec-evidence-item {\n  padding: 6px 8px;\n  background: var(--surface-soft);\n  border-left: 2px solid var(--accent);\n  border-radius: 0 6px 6px 0;\n}\n.ec-ev-source { font-size: 0.68rem; font-weight: 700; color: var(--accent); }\n.ec-ev-text {\n  font-size: 0.75rem;\n  color: var(--text-soft);\n  margin: 3px 0 0;\n  line-height: 1.45;\n}\n.ec-reflection {\n  font-size: 0.73rem;\n  color: var(--text-muted);\n  font-style: italic;\n  padding: 3px 0;\n  border-bottom: 1px solid var(--border);\n}\n.ec-reflection:last-child { border-bottom: none; }\n.ec-final-answer {\n  font-size: 0.78rem;\n  color: var(--text-soft);\n  line-height: 1.5;\n  padding: 8px;\n  background: var(--surface-soft);\n  border-radius: 6px;\n}\n\n/* ── LLM Chain Degradation Visual Comparison ─────────────────────────────── */\n.chain-compare {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 24px;\n  align-items: start;\n  margin: 8px 0 24px;\n}\n.chain-col {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.chain-col-header {\n  text-align: center;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 7px 14px;\n  border-radius: 8px 8px 0 0;\n  margin-bottom: 0;\n}\n.chain-col-header--bad {\n  background: rgba(220, 38, 38, 0.08);\n  color: var(--negative);\n  border: 1px solid rgba(220, 38, 38, 0.18);\n  border-bottom: none;\n}\n.chain-col-header--good {\n  background: rgba(5, 150, 105, 0.08);\n  color: var(--positive);\n  border: 1px solid rgba(5, 150, 105, 0.18);\n  border-bottom: none;\n}\n.chain-steps {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border);\n  border-radius: 0 0 10px 10px;\n  padding: 16px 14px 12px;\n  background: var(--surface);\n}\n.chain-step-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.chain-connector {\n  width: 2px;\n  height: 14px;\n  align-self: center;\n}\n.chain-connector--solid {\n  background: var(--negative);\n  opacity: 0.5;\n}\n.chain-connector--dotted {\n  border-left: 2px dashed var(--positive);\n  opacity: 0.5;\n  background: none;\n}\n.chain-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n  padding: 9px 11px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n}\n.chain-step--bad {\n  border-color: rgba(220, 38, 38, 0.15);\n}\n.chain-step--good {\n  border-color: rgba(5, 150, 105, 0.2);\n  opacity: 1 !important;\n}\n.chain-step-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text);\n  text-align: center;\n  width: 100%;\n}\n.chain-step-acc {\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n.chain-badges {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin-top: 2px;\n}\n.chain-badge {\n  font-size: 0.62rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: rgba(5, 150, 105, 0.1);\n  color: var(--positive);\n  border: 1px solid rgba(5, 150, 105, 0.2);\n}\n.chain-verdict {\n  margin-top: 10px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n.chain-verdict--bad {\n  color: var(--negative);\n  background: rgba(220, 38, 38, 0.06);\n}\n.chain-verdict--good {\n  color: var(--positive);\n  background: rgba(5, 150, 105, 0.06);\n}\n.chain-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  padding-top: 48px;\n}\n@media (max-width: 860px) {\n  .chain-compare {\n    grid-template-columns: 1fr;\n  }\n  .chain-divider {\n    padding-top: 0;\n    text-align: center;\n  }\n}\n\n/* ── Chain Degradation Explainer ─────────────────────────────────────────── */\n.chain-degradation-explainer {\n  max-width: 780px;\n  margin: 0 auto 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.chain-degradation-explainer p {\n  font-size: 0.95rem;\n  color: var(--text-soft);\n  line-height: 1.7;\n  text-align: center;\n}\n.chain-degradation-explainer strong {\n  color: var(--text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
